module.exports = __webpack_public_path__ + "static/media/37-1.760b99ea.mp3";